import { path } from '../lib/ramda'

const UrlHelper = {
  getUrlValues: (pathname?: string, pageResources?: any) => {
    if (!pathname) {
      return ''
    }
    const matchedPath = path(['page', 'path'], pageResources)
    return pathname.replace(matchedPath, '').split('/')
  },
}

export { UrlHelper }
